(function () {
  'use strict';
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var shell = root.querySelector('[data-gallery-shell]');
    var list = root.querySelector('.splide__list');
    var component = root.querySelector('[data-gallery-slider]');
    var lightbox = root.querySelector('[role="dialog"]');
    var fullImage = lightbox.querySelector('.lb__img');
    var photos = [], seen = new Set(), cursors = new Set();
    var cursor = null, hasMore = true, loading = false, slider = null, active = 0, opener, batches = 0;
    var desktop = Number(component.dataset.slidesDesktop) || 8;
    var mobile = Number(component.dataset.slidesMobile) || 2;
    function safeURL(value) {
      try { var url = new URL(value); return url.protocol === 'https:' ? url.href : null; }
      catch (_) { return null; }
    }
    function readCache(url) {
      try {
        var entry = JSON.parse(localStorage.getItem('zk-review-photos-v1:' + url));
        if (entry && entry.expires > Date.now() && entry.expires <= Date.now() + 600000) return entry.data;
      } catch (_) {}
      return null;
    }
    function writeCache(url, payload) {
      try { localStorage.setItem('zk-review-photos-v1:' + url, JSON.stringify({expires:Date.now() + 600000,data:payload})); } catch (_) {}
    }
    function close() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lb-no-scroll');
      fullImage.removeAttribute('src');
      if (opener) opener.focus();
    }
    function open(index) {
      if (!photos.length) return;
      active = (index + photos.length) % photos.length;
      fullImage.src = photos[active];
      fullImage.alt = root.dataset.photoLabel;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lb-no-scroll');
      lightbox.querySelector('.lb__close').focus();
      if (active >= photos.length - 2) load();
    }
    function addPhoto(url) {
      var index = photos.length;
      photos.push(url); seen.add(url);
      var slide = document.createElement('li');
      slide.className = 'splide__slide';
      // Use the original keyboard carousel markup and CSS classes unchanged.
      slide.innerHTML = '<div class="splide__slide__container"><div class="image-slide animate-item animate-item--child"><div class="image-slide__image media media--transparent ratio media--cover" style="--ratio-percent:133.333333%"><button type="button" class="image-slide__btn"><img loading="lazy" decoding="async"></button></div></div></div>';
      var button = slide.querySelector('button'), image = slide.querySelector('img');
      slide.querySelector('.image-slide').style.setProperty('--index', index);
      button.setAttribute('aria-label', root.dataset.openLabel);
      button.dataset.full = url;
      button.addEventListener('click', function () { opener = button; open(index); });
      image.alt = root.dataset.photoLabel;
      image.addEventListener('load', function () {
        if (image.naturalWidth) image.parentElement.parentElement.style.setProperty('--ratio-percent', (image.naturalHeight / image.naturalWidth * 100) + '%');
        if (slider) slider.refresh();
      });
      image.src = url;
      if (slider) slider.add(slide); else list.appendChild(slide);
    }
    function mount() {
      if (slider || !photos.length || typeof window.Splide !== 'function') return;
      shell.hidden = false;
      shell.classList.remove('animate--hidden');
      slider = new window.Splide(root.querySelector('.splide'), {
        type:'slide', direction:document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr',
        perPage:desktop, perMove:1, gap:Number(component.dataset.gapDesktop),
        pagination:component.dataset.desktopDots !== 'hidden', arrows:true, omitEnd:true,
        paddingCalc:true, padding:{left:0,right:0},
        breakpoints:{749:{perPage:mobile,gap:Number(component.dataset.gapMobile),pagination:component.dataset.mobileDots !== 'hidden'}}
      });
      slider.on('moved', function (index) { if (index + slider.options.perPage >= photos.length - 2) load(); });
      slider.mount();
    }
    function load() {
      if (loading || !hasMore) return Promise.resolve();
      loading = true;
      var url = root.dataset.apiBase + '/api/reviews/' + encodeURIComponent(root.dataset.productId) + '?has_images=true&sort=recent&limit=5';
      if (cursor) url += '&cursor=' + encodeURIComponent(cursor);
      var cached = readCache(url);
      return (cached ? Promise.resolve(cached) : fetch(url, {headers:{Accept:'application/json'},signal:AbortSignal.timeout(12000)}).then(function (response) {
        if (!response.ok) throw new Error('Review photos unavailable');
        return response.json();
      })).then(function (payload) {
        if (payload.product_id !== root.dataset.productId || !Array.isArray(payload.data) || !payload.pagination) throw new Error('Invalid review photos');
        batches += 1;
        writeCache(url, payload);
        payload.data.forEach(function (review) {
          if (!Array.isArray(review.image_urls)) return;
          review.image_urls.forEach(function (value) { var image = safeURL(value); if (image && !seen.has(image)) addPhoto(image); });
        });
        var next = payload.pagination.next_cursor;
        hasMore = Boolean(payload.pagination.has_more && next && !cursors.has(next) && payload.data.length);
        if (hasMore) cursors.add(next);
        cursor = next || null;
        mount();
      }).catch(function () {
        // Keep already loaded photos; an empty gallery remains completely hidden.
        hasMore = false;
      }).finally(function () {
        loading = false;
        // At most two batches initially: fill the desktop row and enable navigation.
        if (hasMore && photos.length <= desktop && batches < 2) load();
      });
    }
    lightbox.querySelectorAll('[data-close]').forEach(function (button) { button.addEventListener('click', close); });
    lightbox.querySelector('[data-prev]').addEventListener('click', function () { open(active - 1); });
    lightbox.querySelector('[data-next]').addEventListener('click', function () {
      if (active === photos.length - 1 && hasMore) load().then(function () { open(active + 1); });
      else open(active + 1);
    });
    lightbox.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowRight') open(active + 1);
      if (event.key === 'ArrowLeft') open(active - 1);
      if (event.key === 'Tab') {
        var controls = Array.from(lightbox.querySelectorAll('button'));
        var first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    var touchX;
    lightbox.addEventListener('touchstart', function (event) { touchX = event.changedTouches[0].clientX; }, {passive:true});
    lightbox.addEventListener('touchend', function (event) {
      var distance = event.changedTouches[0].clientX - touchX;
      if (Math.abs(distance) > 50) open(active + (distance < 0 ? 1 : -1));
    }, {passive:true});
    // Fetch just five photo reviews near the carousel, never scan all reviews.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) { observer.disconnect(); load(); }
      }, {rootMargin:'600px'});
      observer.observe(root);
    } else load();
  }
  function boot() { document.querySelectorAll('[data-review-photo-gallery]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
}());
